<template>
    <div id="floating-images">
        <section id="images-section">
            <img src="/img/saas/pamoja.png" alt="A SPIRITT App" class="pamoja-phone">
            <img src="/img/saas/perpage.png" alt="A SPIRITT App" class="perpage-tablet">
            <img src="/img/saas/vidback.png" alt="A SPIRITT App" class="feedy-tablet">
            <img src="/img/saas/willyou.png" alt="A SPIRITT App" class="willyou-phone">
        </section>
    </div>
</template>

<script>
    export default {
        name: 'floating-images',
    }
</script>

<style lang="css" scoped>
    #images-section {
        pointer-events: none;
        position: absolute;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 1287px;
        left: 50%;
        margin-left: -644px;
        -webkit-transform: scale(.5) rotate(-12deg) translateX(50px);
        transform: scale(.5) rotate(-12deg) translateX(50px);
        -webkit-transform-origin: 50% 20%;
        transform-origin: 50% 20%;
        z-index: 5;
    }
    #images-section img {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-radius: 38px;
        background: #fff;
        -webkit-box-shadow: inset 0 4px 7px 1px #fff, inset 0 -5px 20px rgba(173,186,204,.25), 0 2px 6px rgba(0,21,64,.14), 0 10px 20px rgba(0,21,64,.05);
        box-shadow: inset 0 4px 7px 1px #fff, inset 0 -5px 20px rgba(173,186,204,.25), 0 2px 6px rgba(0,21,64,.14), 0 10px 20px rgba(0,21,64,.05);
    }
    .pamoja-phone {
        width: 208px;
        height: 416px;
        margin: 0 30px 0;
    }
    .perpage-tablet {
        width: 480px;
        height: 277.45px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-top: 125px;
        margin-right: 30px;
        border-radius: 23px !important;
    }
    .willyou-phone {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 208px;
        height: 416px;
        margin-top: 50px;
    }
    .feedy-tablet {
        -webkit-box-ordinal-group: 1;
        -ms-flex-order: 0;
        order: 0;
        margin: 50px 30px 0 0;
        width: 480px;
        height: 280px;
        border-radius: 23px !important;
    }
    @media (min-width: 1450px) {
        #images-section {

        }
        .pamoja-phone {
            width: 258px;
            height: 514px;
            margin: 0 30px 0;
        }
        .perpage-tablet {
            width: 700px;
            height: 405px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            margin-top: 125px;
        }
        .willyou-phone {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            width: 258px;
            height: 514px;
            margin-top: 50px;
        }
        .feedy-tablet {
            -webkit-box-ordinal-group: 1;
            -ms-flex-order: 0;
            order: 0;
            margin: 50px 30px 0 0;
            width: 700px;
            height: 405px;
        }
    }
    @media (min-width: 780px) {
        #images-section {
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            width: 512px;
            margin-left: -50px;
            top: 215px;
            -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
            -webkit-transform-origin: 100% 0;
            transform-origin: 100% 0;
        }
    }
    @media (min-width: 880px) {
        #images-section {
            width: 1200px;
            top: 20px;
        }
    }
    @media (max-width: 770px) {
        #images-section {
            top: calc(100vh - 55px);
            left: 40%;
            transform: scale(.5) rotate(-6deg) translateX(50px);
        }
        .pamoja-phone {
            width: auto !important;
            height: 416px;
            margin: 0 30px 0;
        }
        .perpage-tablet {
            width: auto !important;
            height: 280px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            margin-top: 125px;
            margin-right: 30px;
        }
        .willyou-phone {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            width: 208px;
            height: 416px;
            margin-top: 50px;
        }
        .feedy-tablet {
            -webkit-box-ordinal-group: 1;
            -ms-flex-order: 0;
            order: 0;
            margin: 50px 30px 0 0;
            width: auto !important;
            height: 280px;
        }
    }
    @media (max-width: 760px) {
        #images-section {
            top: calc(100vh - 55px);
            left: 60%;
            transform: scale(.5) rotate(-6deg) translateX(50px);
        }
        .pamoja-phone {
            width: auto !important;
            height: 416px;
            margin: 0 30px 0;
        }
        .perpage-tablet {
            width: auto !important;
            height: 280px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            margin-top: 125px;
            margin-right: 30px;
        }
        .willyou-phone {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            width: 208px;
            height: 416px;
            margin-top: 50px;
        }
        .feedy-tablet {
            -webkit-box-ordinal-group: 1;
            -ms-flex-order: 0;
            order: 0;
            margin: 50px 30px 0 0;
            width: auto !important;
            height: 280px;
        }
    }
</style>
